const ManageStorage = {
    setItemStorage(itemName, value) {
        localStorage.setItem(itemName, value);
    },
    getValueFromStorage(itemName) {
        return localStorage.getItem(itemName);
    },
    removeItemFromStorage(itemName) {
        localStorage.removeItem(itemName);
    },
    clearAllStorage() {
        localStorage.clear();
    }
}

export default ManageStorage;